import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators'
import { credentialsKey } from './credentials.service';
import { UserRoles, UserConfirmationRoles } from '../shared/models/user.interface'
import { IfStmt } from '@angular/compiler';
import { Router } from '@angular/router';
@Injectable()
export class AuthenticationService {
  private params: any;

  setCurrentLogin(params) {
    this.params = params;
  }
  getCurrentLogin() {
    return this.params;
  }
  constructor(
    private httpClient: HttpClient,
    private router: Router,
  ) { }

  /**
   * Authenticates the user.
   * @param {signInContext} body The login parameters.
   * @return {Observable<Credentials>} The user credentials.
   */
  signIn(body: any): Observable<any> {
    // Replace by proper authentication call
    return this.httpClient.post('api/user/signIn', body)
      .pipe(
        map((body) => {
          if (body == 500) {
            throw new Error('error');
          } else {
            return body;
          }
        })
      );
  }

  /**
 * Authenticates the user.
 * @param {signInContext} body The login parameters.
 * @return {Observable<Credentials>} The user credentials.
 */
  adminSignIn(body: any): Observable<any> {
    // Replace by proper authentication call
    return this.httpClient.post('api/user/adminSignIn', body)
      .pipe(
        map((body) => {
          if (body == 500) {
            throw new Error('error');
          } else {
            return body;
          }
        })
      );
  }
  // getSuperAdminHomeUrl() {
  //   const userData = this.getUser();
  //   let role;
  //   if (!userData) {
  //     return 'login';
  //   }else{
  //     return '/admin';
  //   }
  // }

  getCodeEnforcementHomeUrl() {
    const userData = this.getUser();
    let role;
    if (!userData) {
      return 'code-sign-in';
    }
    return '/enforcement';
  }


  getHomeUrl(currentLogin?) {
    const userData = this.getUser();
    console.log(currentLogin);
    // let role;
    // const navigateUrl = JSON.stringify(currentLogin).replace(/[{}']/g, "").replace(':', '=').replace(/["']/g, "");
    if (userData == null) {
      let currentUserLogin = Object.keys(currentLogin)[0];
      if(UserConfirmationRoles[currentUserLogin.toUpperCase()] == UserRoles.OFFICER){
        this.router.navigate(['/login', { isOfficer: UserRoles.OFFICER }], { replaceUrl: true })
      }
      if(UserConfirmationRoles[currentUserLogin.toUpperCase()] == UserRoles.STAFF){
        this.router.navigate(['/login', { isVillageStaff: UserRoles.STAFF }], { replaceUrl: true });
      }
      if(UserConfirmationRoles[currentUserLogin.toUpperCase()] == UserRoles.ADMIN){
        this.router.navigate(['/login', { isAdmin: UserRoles.ADMIN }], { replaceUrl: true })
      }
      // console.log('haha.......');
      // // this.router.navigate(['/login', {navigateUrl}], { replaceUrl: true })
      // return '/login'+navigateUrl;
      // return;
    
        // this.router.navigate(['/login', {navigateUrl}], { replaceUrl: true })
        return;
      
    }else if (userData) {
      const officerRole = JSON.parse(userData).userRoles.filter(u => u.roleId == UserRoles.OFFICER);
      const staffRole = JSON.parse(userData).userRoles.filter(u => u.roleId == UserRoles.STAFF);
      const adminRole = JSON.parse(userData).userRoles.filter(u => u.roleId == UserRoles.ADMIN);
      const superAdminRole = JSON.parse(userData).userRoles.filter(u => u.roleId == UserRoles.SUPER_ADMIN);
      console.log(currentLogin, 'currentLogin', adminRole)
      // const user_role = JSON.parse(userData).userRoles? JSON.parse(userData).userRoles[0].role.name : null;
      const user_role = 'Admin';
      // adminRole.length !== 0 && adminRole[0].role.name == 'Admin' &&
      if (user_role == null) {
        return '/admin';
      }
      if (user_role != 'Admin') {
        // return '/admin';
      } else if ((officerRole.length !== 0 && officerRole[0].role.name == 'Officer' && currentLogin.isOfficer) || (adminRole.length !== 0 && adminRole[0].role.name == 'Admin' && currentLogin.isOfficer)) {
        return '/officer';
      } else if ((staffRole.length !== 0 && staffRole[0].role.name == 'Staff' && currentLogin.isVillageStaff) || (adminRole.length !== 0 && adminRole[0].role.name == 'Admin' && currentLogin.isVillageStaff)) {
        return '/staff';
      }else if((officerRole.length !== 0 && officerRole[0].role.name == 'Officer' && adminRole.length !== 0 && adminRole[0].role.name == 'Admin') && currentLogin.isAdmin){
        return '/admin';
      }
      else if(adminRole.length !== 0 && adminRole[0].role.name == 'Admin' && currentLogin.isAdmin){
        return '/admin';
      }
      // else if (currentLogin.isAdmin) {
      //   return '/admin';
     // }
       else if (superAdminRole.length !== 0 && superAdminRole[0].role.name == 'Super_Admin' && currentLogin.isAdmin) {
        return '/admin';
      } 
    }
  }

  public getUser() {
    const savedCredentials = localStorage.getItem(credentialsKey);
    return savedCredentials ? savedCredentials : null;
  }

}

